import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MdClose from 'react-icons/lib/md/close';

import css from '../styles/modal';

class Modal extends Component {
    static propTypes = {
        title: PropTypes.string,
        symbol: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        children: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this._onClick = (event) => {
            event.preventDefault();
            this.props.onClick();
        };

        this._stopPropagation = e => e.stopPropagation();
    }

    componentDidMount() {
        document.body.classList.add('menuOpen');
    }

    componentWillUnmount() {
        document.body.classList.remove('menuOpen');
    }

    render() {
        const { title, children, symbol } = this.props;

        return (
            <div className={css.backdrop} onClick={this._onClick}>
                <div className={css.container} onClick={this._stopPropagation}>
                    {title && <div className={css.titleWrapper}>
                        <div>
                            <h3 className={css.symbol}>{symbol}</h3>
                            <h2 className={css.title}>{title}</h2>
                        </div>
                        <div className={css.close} onClick={this._onClick}>
                            <MdClose />
                        </div>
                    </div>}
                    <div className={css.inner}>
                        { children }
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;



/** WEBPACK FOOTER **
 ** /src/shared/components/Modal.js
 **/